import $ from 'jquery';
import { LazyLoad } from 'Util/lazyload';
import { NavLoad } from 'App/nav/load';
import { Tooltip } from 'App/tooltip/tooltip';
import { Summary } from 'App/form/summary';
import { Accordion } from 'App/accordion/accordion';
import { Social } from 'App/social/share';
import { AntidoteCustom } from 'App/antidote/antidote.custom';
import 'magnificPopup';

LazyLoad.init();
NavLoad.init();
Tooltip.init();
Accordion.init();
Social.init();

if (document.querySelector('.js-questionnaire')) {
	import(/* webpackChunkName: "Questionaire" */ 'App/form/questionnaire').then(({ Questionnaire }) => {
		Questionnaire.init();
	});
}

if (document.querySelector('.js-summary')) {
	Summary.init();
}

if (document.querySelectorAll('.js-antidote-medical-screening')) {
	AntidoteCustom.init();
}

// Cookie helper functions
const setCookie = (name, value) => {
	// Set session cookie (clears when browser closes)
	document.cookie = `${name}=${value}; path=/; SameSite=Lax`;
};

const getCookie = (name) => {
	const value = `; ${document.cookie}`;
	const parts = value.split(`; ${name}=`);
	if (parts.length === 2) return parts.pop().split(';').shift();
	return null;
};

// Checking if user chose TA site before showing modal
if (document.querySelector('.js-modal-site-switch')) {
	const modal = document.querySelector('.js-modal-site-switch');
	const modalLinks = modal.querySelectorAll('.c-modal-site-switch__link');
	const COOKIE_KEY = 'siteSwitchModalShown';

	// Check if modal was already shown (stored in cookie)
	const hasSeenModal = getCookie(COOKIE_KEY);

	if (!hasSeenModal) {
		// Show modal on first visit
		modal.setAttribute('aria-hidden', 'false');
	} else {
		// Hide modal if already shown
		modal.setAttribute('aria-hidden', 'true');
	}

	// Add click event listeners to all modal links
	modalLinks.forEach(link => {
		link.addEventListener('click', () => {
			// Store in cookie
			setCookie(COOKIE_KEY, 'true');
			// Hide modal
			modal.setAttribute('aria-hidden', 'true');
		});
	});
}

//if (document.querySelector('.js-modal')) {
//	modal.init();
//}

// Single and Multi Image Lightbox
if ($('.js-lightbox-single').length) {
	if (document.querySelectorAll('.js-lightbox-single')) {
		$('.js-lightbox-single').magnificPopup({
			delegate: '.js-lightbox-image',
			type: 'image'
		});
	}
}

// Sanitize HTML
import sanitizeHtml from 'sanitize-html';

const body = document.querySelector('body');

sanitizeHtml(body);